// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const vat: CountryValidator<"SE"> = createValidator(
  "se.vat",
  156,
);

export default vat;
export const compact = vat.compact;
export const format = vat.format;
export const validate = vat.validate;
export const generate = (): string =>
  vat.generate?.() ??
  (() => {
    throw new Error(
      "Validator se.vat cannot generate values",
    );
  })();
